<template>
	<div class="home">
		<Encabezado></Encabezado>

		<div id="content" class="snap-content bg-home">
			<div class="container">
				<div class="header-clear"></div>
				<div id="itemList">
					<div class="itemList-controls">
						<div class="controls controls-right">
							<router-link v-if="maximoDias > 0" class="btn GeneralLeave-back btnBack" to="/vacaciones/nuevas">
							    <font-awesome-icon icon="fa-solid fa-circle-plus" /> Nuevas Vacaciones
							</router-link>
							<a v-else href="javascript:void(0);" class="btn GeneralLeave-back btnBack" @click="avisoSinDiasPendientes">
							    <font-awesome-icon icon="fa-solid fa-circle-plus" /> Nuevas Vacaciones
							</a>
						</div>
						<div class="title">
							<h3>Vacaciones</h3>
						</div>
					</div>

					<div class="itemList-header">
						<h1>Solicitudes de vacaciones</h1>
						<!--<h1>Solicitudes de vacaciones {{ vacaciones }}</h1>-->
					</div>
					<div class="itemList-content row">
						<section id="no-more-tables" class="col-md-12 text-center">
							<table class="table" id="tblHolidayLeave-Resume">
								<thead>
									<tr>
										<th class="colDate">Año</th>
										<th class="colSolic">Días Solicitados</th>
										<th class="colAprob">Días Aprobados</th>
										<th class="colPend">Días Pendientes</th>
										<th class="colTotal">Total Días</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="resumen in vacaciones.resumen">
										<td class="colDate" data-title="Año Actual">{{ resumen.anio }}</td>
										<td class="colSolic" data-title="Dias Solicitados">{{ resumen.diasSolicitados }}</td>
										<td class="colAprob" data-title="Dias Aprobados">{{ resumen.diasAprobados }}</td>
										<td class="colPend" data-title="Dias Pendientes">{{ resumen.diasPendientes }}</td>
										<td class="colTotal" data-title="Total Días">{{ resumen.dias}}</td>
									</tr>
								</tbody>
							</table>
						</section>

						<!---->
						<div v-if="vacaciones.registros.length == 0" class="AdvanceRequest-title col-md-12 NotFound text-center"> No hay resultados </div>
						<section v-else id="no-more-tables" class="col-md-12 text-center">
							<table class="table" id="tblHolidayLeave">
								<thead>
									<tr>
										<th class="colDate">Fecha desde</th>
										<th class="colDate">Fecha hasta</th>
										<th class="colTotal">Total Días</th>
										<th class="colType">Estado</th>
										<th class="colAction">Acción</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="vacacion in vacaciones.registros">
										<td class="colDate" data-title="Fecha desde : ">
											{{ formatDate(vacacion.fechaDesde) }}
										</td>
										<td class="colDate" data-title="Fecha hasta : ">
											{{ formatDate(vacacion.fechaHasta) }}
										</td>
										<td class="colTotal" data-title="Total Dias: ">
											{{ vacacion.dias }}
										</td>
										<td class="colType" data-title="Estado : ">
											{{ vacacion.estado }}
										</td>
										<td class="colAction" data-title="Acción : ">
											<!--<router-link :to="`/vacaciones/editar/${vacacion.id}`">
												<font-awesome-icon icon="fa-solid fa-pencil" />
											</router-link>-->
											<a 
												v-if="vacacion.estado=='En Curso'" 
												href="javascript:void(0);" 
												class="btnDelete"
												@click="borrar(vacacion.id)"	
											>
												<font-awesome-icon icon="fa-solid fa-times" />
											</a>
											<router-link :to="`/vacaciones/ver/${vacacion.id}`">
												<font-awesome-icon icon="fa-solid fa-eye" />
											</router-link>
											&nbsp;&nbsp;
										</td>
									</tr>
								</tbody>
							</table>
						</section>
					</div>
					<div class="itemList-footer">
						<div class="pagination text-center holidayleave-paging"></div>
					</div>
				</div>
			</div>
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import Encabezado from "@/components/Encabezado.vue";
import Footer from "@/components/Footer.vue";

export default {
	name: "Vacaciones",
	components: {
		Encabezado,
		Footer,
	},
	mounted() {
		this.$store.commit('establecerGuardadoOK', false);

		document.body.classList.remove("bg-login");
		document.body.classList.remove("login-page");
	},
	watch:{
		guardadoOK: function(newValue){
			if (newValue){
				this.$toast.open({
					message: "La Solicitud se ha borrado correctamente",
					type: "success",
					duration: 1000,
					dismissible: false,
					position: "top",
					onDismiss: this.redireccionListaVacaciones
				});
			}
		}
	},
	computed:{
		vacaciones: function(){
			let vacaciones = this.$store.state.perfil.vacaciones;

			console.log(JSON.stringify(this.$store.state.perfil));
			
			vacaciones.resumen = Array.isArray(vacaciones.resumen)? vacaciones.resumen : [vacaciones.resumen];
			vacaciones.registros = (!!vacaciones.registros)?vacaciones.registros : [];
			vacaciones.registros = (Array.isArray(vacaciones.registros)?vacaciones.registros:[vacaciones.registros]);

			return vacaciones;
		},
		guardadoOK: function(){
			return this.$store.state.guardadoOK;
		},
		maximoDias: function(){
			let maximoDias = 0;
			let resumenVacaciones;

			if (!!this.$store.state.perfil.vacaciones){
				resumenVacaciones = this.$store.state.perfil.vacaciones.resumen || [];
				resumenVacaciones = ((Array.isArray(resumenVacaciones))? resumenVacaciones : [resumenVacaciones]);
				resumenVacaciones = resumenVacaciones.filter((r) => !!(r.activo * 1));

				maximoDias = resumenVacaciones[0].diasPendientes;
			}
			return maximoDias;
		},
	},
	methods:{
		formatDate: function(date) {
			return this.moment(date).format('DD/MM/YYYY');
		},
		borrar(id){
			if (confirm('Atención: Borrar Solicitud de Vacaciones'))
				this.$store.dispatch('borrarVacaciones', {'id': id});
		},
		redireccionListaVacaciones: function(){
			//router.replace('/vacaciones');
			this.$store.commit('establecerGuardadoOK', false);
		},
		avisoSinDiasPendientes(){
			alert("Atención: ya no hay días pendientes para unas nuevas vacaciones");
		}
	}

};
</script>

<style>
    @import "../assets/styles/home.css";
</style>
